export type BreakdownItem = {
  label: string
  count: number
  /** Optional secondary value rendered after the count (e.g. formatted money). */
  detail?: string
}

/** Label + relative bar + count rows, for status/tier distributions. */
export function BreakdownList({ items }: { items: BreakdownItem[] }) {
  const max = Math.max(1, ...items.map((i) => i.count))
  return (
    <div className="space-y-1.5">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-2 text-xs">
          <span className="w-44 shrink-0 truncate text-muted-foreground" title={item.label}>
            {item.label}
          </span>
          <div className="h-2 flex-1 rounded-full bg-muted/40">
            <div
              className="h-2 rounded-full bg-chart-2/80"
              style={{ width: `${Math.max(2, (item.count / max) * 100)}%` }}
            />
          </div>
          <span className="w-20 shrink-0 text-right tabular-nums text-foreground">
            {item.count.toLocaleString()}
          </span>
          {item.detail && (
            <span className="w-20 shrink-0 text-right tabular-nums text-muted-foreground">
              {item.detail}
            </span>
          )}
        </div>
      ))}
    </div>
  )
}
